<div id="page_content">
  <div id="page_content_header" class="uk-blur-background" style="margin-top: 0"></div>
  <div id="page_content_actions" class="uk-blur-background" uk-sticky>
    <sidebar-mobile-toggle [activeSidebarItemStatic]="'Repositories'" class="uk-hidden@m"></sidebar-mobile-toggle>
  </div>
  <div id="page_content_inner" class="">


    <div class="uk-section uk-section-small">
      <div class="uk-container">

        <div class="uk-flex uk-flex-middle uk-margin-bottom">
          <img ngSrc="../../survey-tool/assets/images/flags/{{countryCode | lowercase}}-flag-round.png"
            class="flag-image" width="42" height="42" alt="rounded flag image">
          <div class="uk-margin-small-left">
            <h3 class="uk-margin-remove-bottom">{{ countryName }}</h3>
          </div>
        </div>

        <div class="uk-flex uk-flex-between uk-flex-middle">
          <h4>Repositories</h4>
        </div>

        <p>Repositories are essential for the uptake and advancement of Open Science, providing secure platforms for
          storing, sharing, and preserving research outputs in line with FAIR principles. They promote transparency,
          reproducibility, and collaboration while supporting long-term knowledge preservation. By connecting national
          and regional research systems, repositories play a key role in advancing Open Science and contributing to the
          EOSC.
          This page provides an overview of the state of repositories in Europe based on the data from the Survey on
          National Contributions to EOSC and Open Science.</p>

        <div class="uk-grid-small" data-uk-grid>
          <div class="uk-width-expand" *ngIf="hasAnyLeftCardData()">
            <div class="uk-card uk-card-default uk-card-body visualisation-card">
              <div class="uk-child-width-1-2 uk-grid-small" data-uk-grid>

                <!-- Card 1 -->
                <div *ngIf="OpenRepositoriesPercentage[1] !== null" class="uk-animation-scale-up">
                  <div class="uk-card card-simple uk-card-small uk-card-body">
                    <p>Percentage of <span class="uk-text-bold">Open Repositories in {{ countryName }}</span></p>
                    <div class="number big uk-margin-medium-top">
                      <span class="uk-text-bold">{{ OpenRepositoriesPercentage[1] }}%</span>
                    </div>
                    <div *ngIf="OpenRepositoriesPercentageDiff !== null"
                      class="uk-flex uk-flex-between uk-flex-bottom uk-width-1-1">
                      <div class="uk-flex uk-flex-middle">
                        <span class="material-symbols-outlined"
                          [ngClass]="OpenRepositoriesPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                          {{ OpenRepositoriesPercentageDiff >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                        </span>
                        <span
                          [ngClass]="OpenRepositoriesPercentageDiff >= 0 ? 'percentage-up-color' : 'percentage-down-color'">
                          {{ Math.abs(OpenRepositoriesPercentageDiff) }}%
                        </span>&nbsp; vs last year
                      </div>
                      <div>
                        <img
                          [ngSrc]="'../assets/images/explore/' + (OpenRepositoriesPercentageDiff >= 0 ? 'trend_green' : 'trend_red') + '.svg'"
                          alt="trend image" height="50" width="99">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card 2 -->
                <div *ngIf="rfoOpenRepositoriesPercentage[1] !== null" class="uk-animation-scale-up">
                  <div class="uk-card card-simple uk-card-small uk-card-body">
                    <p>Percentage of <span class="uk-text-bold">RFO's Policy on Repositories</span></p>
                    <div class="number big uk-margin-medium-top">
                      <span class="uk-text-bold">{{ rfoOpenRepositoriesPercentage[1] }}%</span>
                    </div>
                    <div *ngIf="rfoOpenRepositoriesPercentageDiff !== null"
                      class="uk-flex uk-flex-between uk-flex-bottom uk-width-1-1">
                      <div class="uk-flex uk-flex-middle">
                        <span class="material-symbols-outlined"
                          [ngClass]="rfoOpenRepositoriesPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                          {{ rfoOpenRepositoriesPercentageDiff >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                        </span>
                        <span
                          [ngClass]="rfoOpenRepositoriesPercentageDiff >= 0 ? 'percentage-up-color' : 'percentage-down-color'">
                          {{ Math.abs(rfoOpenRepositoriesPercentageDiff) }}%
                        </span>&nbsp; vs last year
                      </div>
                      <div>
                        <img
                          [ngSrc]="'../assets/images/explore/' + (rfoOpenRepositoriesPercentageDiff >= 0 ? 'trend_green' : 'trend_red') + '.svg'"
                          alt="trend image" height="50" width="99">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card 3 -->
                <div *ngIf="repositoriesfinancialInvestment[1] !== null" class="uk-animation-scale-up">
                  <div class="uk-card card-simple uk-card-small uk-card-body">
                    <p>Total <span class="uk-text-bold">financial investment in repositories</span></p>
                    <div class="number big uk-margin-medium-top">
                      <span class="uk-text-bold">{{ repositoriesfinancialInvestment[1] + ' mil Euro' }}</span>
                    </div>
                    <div *ngIf="repositoriesfinancialInvestmentPercentageDiff !== null"
                      class="uk-flex uk-flex-between uk-flex-bottom uk-width-1-1">
                      <div class="uk-flex uk-flex-middle">
                        <span class="material-symbols-outlined"
                          [ngClass]="repositoriesfinancialInvestmentPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                          {{ repositoriesfinancialInvestmentPercentageDiff >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                        </span>
                        <span
                          [ngClass]="repositoriesfinancialInvestmentPercentageDiff >= 0 ? 'percentage-up-color' : 'percentage-down-color'">
                          {{ Math.abs(repositoriesfinancialInvestmentPercentageDiff) }}%
                        </span>&nbsp; vs last year
                      </div>
                      <div>
                        <img
                          [ngSrc]="'../assets/images/explore/' + (repositoriesfinancialInvestmentPercentageDiff >= 0 ? 'trend_green' : 'trend_red') + '.svg'"
                          alt="trend image" height="50" width="99">
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Card 4 -->
                <div *ngIf="rpoOpenRepositoriesPercentage[1] !== null" class="uk-animation-scale-up">
                  <div class="uk-card card-simple uk-card-small uk-card-body">
                    <p>Percentage of <span class="uk-text-bold">RPO's Policy in Repositories</span></p>
                    <div class="number big uk-margin-medium-top">
                      <span class="uk-text-bold">{{ rpoOpenRepositoriesPercentage[1] }}%</span>
                    </div>
                    <div *ngIf="rpoOpenRepositoriesPercentageDiff !== null"
                      class="uk-flex uk-flex-between uk-flex-bottom uk-width-1-1">
                      <div class="uk-flex uk-flex-middle">
                        <span class="material-symbols-outlined"
                          [ngClass]="rpoOpenRepositoriesPercentageDiff >= 0 ? 'up-arrow-color' : 'down-arrow-color'">
                          {{ rpoOpenRepositoriesPercentageDiff >= 0 ? 'arrow_upward' : 'arrow_downward' }}
                        </span>
                        <span
                          [ngClass]="rpoOpenRepositoriesPercentageDiff >= 0 ? 'percentage-up-color' : 'percentage-down-color'">
                          {{ Math.abs(rpoOpenRepositoriesPercentageDiff) }}%
                        </span>&nbsp; vs last year
                      </div>
                      <div>
                        <img
                          [ngSrc]="'../assets/images/explore/' + (rpoOpenRepositoriesPercentageDiff >= 0 ? 'trend_green' : 'trend_red') + '.svg'"
                          alt="trend image" height="50" width="99">
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!-- Right Card-->
          <div class="uk-width-2-5 uk-animation-fade">
            <div class="uk-card uk-card-default uk-card-body visualisation-card">
              <div class="uk-margin-top">
                <h5 class="uk-flex uk-flex-between uk-margin-remove">
                  National Repository Policy
                  <span class="material-symbols-outlined" [ngClass]="{
                  'up-arrow-color': hasNationalPolicyOR === 'Yes',
                  'down-arrow-color': hasNationalPolicyOR === 'No',
                  'unanswered-color': hasNationalPolicyOR === null
                }">
                    {{
                    hasNationalPolicyOR === 'Yes' ? 'check' :
                    hasNationalPolicyOR === 'No' ? 'close' :
                    'question_mark'
                    }}
                  </span>
                </h5>
                <p *ngIf="policyMandatoryOR === 'Yes'" class="uk-text-primary uk-text-bolder uk-margin-remove-top">
                  Mandatory policy</p>
                <read-more-text *ngIf="nationalPolicyClarificationOR" [maxHeight]="68"
                  [text]="nationalPolicyClarificationOR">
                </read-more-text>
              </div>

              <div class="uk-margin-top">
                <h5 class="uk-flex uk-flex-between">
                  Financial Strategy for Repositories
                  <span class="material-symbols-outlined" [ngClass]="{
                  'up-arrow-color': hasFinancialStrategyOR === 'Yes',
                  'down-arrow-color': hasFinancialStrategyOR === 'No',
                  'unanswered-color': hasFinancialStrategyOR === null
                }">
                    {{
                    hasFinancialStrategyOR === 'Yes' ? 'check' :
                    hasFinancialStrategyOR === 'No' ? 'close' :
                    'question_mark'
                    }}
                  </span>
                </h5>
                <read-more-text *ngIf="financialStrategyClarificationOR" [maxHeight]="68"
                  [text]="financialStrategyClarificationOR">
                </read-more-text>
              </div>

              <div class="uk-margin-top">
                <h5 class="uk-flex uk-flex-between">
                  Monitoring of Repositories
                  <span class="material-symbols-outlined" [ngClass]="{
                  'up-arrow-color': hasMonitoringOR === 'Yes',
                  'down-arrow-color': hasMonitoringOR === 'No',
                  'unanswered-color': hasMonitoringOR === null
                }">
                    {{
                    hasMonitoringOR === 'Yes' ? 'check' :
                    hasMonitoringOR === 'No' ? 'close' :
                    'question_mark'
                    }}
                  </span>
                </h5>
                <read-more-text *ngIf="monitoringClarificationOR" [maxHeight]="68" [text]="monitoringClarificationOR">
                </read-more-text>
              </div>
            </div>
          </div>
        </div>
        <div class="uk-margin-top uk-flex uk-flex-center">
          <span class="uk-text-bold ">Data source:</span>&nbsp; Survey on National Contributions to EOSC and Open
          Science
          OpenAIRE Graph.
        </div>

      </div>
    </div>

    <div *ngIf="hasSurveyRepositoriesData()" class="uk-section uk-section-small uk-margin-top">
      <div class="uk-container">

        <div class="uk-margin-medium-top uk-animation-fade">
          <div class=" uk-margin-medium-top uk-card uk-card-body uk-card-default uk-width-1-1 noads visualisation-card">
            <read-more [maxHeight]="300">

              <div id="networks_&_aggregators">
                <div class="uk-text-secondary">Networks & Aggregators of Scientific/Research Content</div>
                <ng-container
                  *ngIf="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question16']?.['Question16-1']; else networks_aggregators">
                  <div
                    [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question16']['Question16-1']"
                    class="uk-margin-medium-top"></div>
                </ng-container>
                <ng-template #networks_aggregators>
                  <p>N/A</p>
                </ng-template>
              </div>
              <div id="literature_repositories">
                <div class="uk-text-secondary">Literature repositories</div>
                <ng-container
                  *ngIf="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question17']?.['Question17-1']; else literature_repositories">
                  <div
                    [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question17']['Question17-1']"
                    class="uk-margin-medium-top"></div>
                </ng-container>
                <ng-template #literature_repositories>
                  <p>N/A</p>
                </ng-template>
              </div>
              <div id="data_repositories">
                <div class="uk-text-secondary">Data repositories</div>
                <ng-container
                  *ngIf="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question18']?.['Question18-1']; else data_repositories">
                  <div
                    [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question18']['Question18-1']"
                    class="uk-margin-medium-top"></div>
                </ng-container>
                <ng-template #data_repositories>
                  <p>N/A</p>
                </ng-template>
              </div>
              <div id="software_repositories">
                <div class="uk-text-secondary">Software repositories</div>
                <ng-container
                  *ngIf="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question19']?.['Question19-1']; else software_repositories">
                  <div
                    [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question19']['Question19-1']"
                    class="uk-margin-medium-top"></div>
                </ng-container>
                <ng-template #software_repositories>
                  <p>N/A</p>
                </ng-template>
              </div>
              <div id="OA_publishing_platforms">
                <div class="uk-text-secondary">OA Publishing Platforms</div>
                <ng-container
                  *ngIf="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question20']?.['Question20-1']; else OA_publishing_platforms">
                  <div
                    [innerHTML]="countrySurveyAnswer['OPEN SCIENCE DIGITAL INFRASTRUCTURE']['Question20']['Question20-1']"
                    class="uk-margin-medium-top"></div>
                </ng-container>
                <ng-template #OA_publishing_platforms>
                  <p>N/A</p>
                </ng-template>
              </div>

            </read-more>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div id="page_content_footer"></div>
</div>
